<template>
  <div class="custom-card">
    <v-toolbar-title class="mb-4 py-2" style="border-bottom: 1px solid #d4dbe0">
      <v-row dense>
        <v-col cols="12" md="12" lg="4" xl="3">
          <span class="h4 my-0">REPORTE DE DESEMBOLSOS</span>
        </v-col>

        <v-col cols="12" md="12" lg="8" xl="9">
          <div class="d-flex flex-wrap align-center">
            <v-btn small class="ma-2" @click="mostrado = true">
              <v-icon>mdi-filter-plus</v-icon>
            </v-btn>

            <v-autocomplete
              class="ma-2"
              v-model="sedesSeleccionadas"
              :disabled="estaActualizando || sedesAgrupadas.length === 0"
              :items="sedesAgrupadas"
              outlined
              small-chips
              dense
              color="blue-grey lighten-2"
              label="Seleccionar sedes"
              item-text="nombre"
              item-value="id"
              clearable
              multiple
              hide-details
              @input="listarTodo">
              <template v-slot:selection="data">
                <v-chip
                  class="my-1"
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  close
                  small
                  @click:close="removerSedeSeleccionada(data.item)">
                  {{ data.item.nombre }}
                </v-chip>
              </template>
              <template v-slot:item="data">
                <template>
                  <v-list-item-content>
                    <v-list-item-title>{{ data.item.nombre }}</v-list-item-title>
                    <v-list-item-subtitle>{{ data.item.group }}</v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </template>
            </v-autocomplete>
          </div>
        </v-col>
      </v-row>
    </v-toolbar-title>

    <v-tabs v-model="tab" background-color="transparent" @change="establecerTabSeleccionada">
      <v-tab tab-value="Por Ítem">Por Ítem</v-tab>
      <v-tab tab-value="Por Sedes">Por Sedes</v-tab>
      <v-tab tab-value="Agrupado">Agrupado</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item value="Por Ítem" :transition="false">
        <v-row dense class="py-4">
          <v-col cols="12">
            <div class="d-flex align-center">
              <div style="max-width: 200px">
                <v-select
                  :items="gestiones"
                  label="Gestion"
                  item-text="numero"
                  item-value="id"
                  v-model="gestionId"
                  @input="onChangeGestionId"
                  placeholder=" "
                  outlined
                  dense
                  hide-details />
              </div>

              <v-btn small class="mx-1" :disabled="sedesSeleccionadas.length == 0 || cargando" @click="listar">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>

              <v-btn small class="mx-1" :disabled="items.length == 0" :loading="cargandoVerPdf" @click="verPdf()">
                <v-icon>mdi-printer</v-icon>
              </v-btn>

              <div class="d-inline-block">
                <v-switch
                  class="mt-0"
                  v-model="mostrarCeros"
                  flat
                  label="Mostrar ceros"
                  hide-details
                  :disabled="sedesSeleccionadas.length == 0"
                  @change="listar"></v-switch>
              </div>
            </div>
          </v-col>

          <v-col cols="12">
            <ListadoReporteEjecucionPresupuestaria
              :items="items"
              :cargando="cargando"></ListadoReporteEjecucionPresupuestaria>
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item value="Por Sedes" :transition="false">
        <v-row dense class="py-4">
          <v-col cols="12">
            <div class="d-flex align-center">
              <div style="min-width: 300px; max-width: 300px">
                <v-menu
                  ref="menu"
                  v-model="menuRangoFechas"
                  :close-on-content-click="false"
                  :return-value.sync="rangoFechas"
                  transition="scale-transition"
                  offset-y
                  min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="rangoFechas"
                      label="Rango de Fechas"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      :disabled="cargandoItemsPorSedes"
                      :rules="[(valor) => valor?.length === 2 || 'El rango de fechas es obligatorio']"
                      required
                      outlined
                      dense
                      clearable
                      hide-details></v-text-field>
                  </template>

                  <v-date-picker
                    v-model="rangoFechas"
                    locale="es-ES"
                    :max="fechaDeHoy()"
                    :disabled="cargandoItemsPorSedes"
                    range
                    no-title
                    scrollable
                    @input="
                      () => {
                        if (rangoFechas?.length === 2) {
                          $refs.menu.save(rangoFechas);
                        }

                        listarItemsPorSedes();
                      }
                    ">
                    <v-spacer></v-spacer>
                  </v-date-picker>
                </v-menu>
              </div>

              <v-btn
                small
                class="mx-1"
                :disabled="sedesSeleccionadas.length == 0 || rangoFechas?.length !== 2 || cargandoItemsPorSedes"
                @click="listarItemsPorSedes">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </div>
          </v-col>

          <v-col cols="12">
            <ListadoReporteDesembolsosPorSedes
              :datos-desembolsos-por-sedes="datosDesembolsosPorSedes"
              :cargando="cargandoItemsPorSedes"></ListadoReporteDesembolsosPorSedes>
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item value="Agrupado" :transition="false">
        <v-row dense class="py-4">
          <v-col cols="12">
            <div class="d-flex align-center">
              <div style="max-width: 200px">
                <v-select
                  :items="gestiones"
                  label="Gestion"
                  item-text="numero"
                  item-value="id"
                  v-model="gestionId"
                  @input="onChangeGestionId"
                  placeholder=" "
                  outlined
                  dense
                  hide-details />
              </div>

              <v-btn small class="mx-1" :disabled="sedesSeleccionadas.length == 0" @click="listarItemsAgrupados">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>

              <v-btn
                small
                class="mx-1"
                :disabled="itemsAgrupados.length == 0"
                :loading="cargandoVerPdf"
                @click="verPdf()">
                <v-icon>mdi-printer</v-icon>
              </v-btn>

              <div class="d-inline-block">
                <v-switch
                  class="mt-0"
                  v-model="mostrarCeros"
                  flat
                  label="Mostrar ceros"
                  hide-details
                  :disabled="sedesSeleccionadas.length == 0"
                  @change="listarItemsAgrupados"></v-switch>
              </div>

              <v-btn
                v-if="itemsAgrupados.length > 0"
                class="mx-1"
                color="primary"
                small
                outlined
                @click="expandirTodo = !expandirTodo">
                <v-icon small left>{{ expandirTodo ? 'mdi-collapse-all' : 'mdi-expand-all' }}</v-icon>

                {{ expandirTodo ? 'Colapsar Todo' : 'Expandir Todo' }}
              </v-btn>
            </div>
          </v-col>

          <v-col cols="12">
            <ListadoReporteEjecucionPresupuestariaAgrupado
              :items="itemsAgrupados"
              :cargando="cargandoItemsAgrupados"
              :expand-all="expandirTodo" />
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>

    <v-dialog v-model="mostrado" max-width="100%" scrollable persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Seleccionar Sedes</span>

          <v-btn
            v-if="sedesSeleccionadas.length == 0"
            small
            class="ml-4 my-1"
            color="primary"
            @click="sedesSeleccionadas = sedes.map((sede) => sede.id)">
            <v-icon>mdi-filter</v-icon>
          </v-btn>

          <v-btn
            v-else
            small
            class="ml-4 my-1"
            :color="sedesSeleccionadas.length == sedes.length ? 'primary' : ''"
            @click="sedesSeleccionadas = []">
            <v-icon>mdi-filter-off</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
          <v-progress-circular
            v-if="sedesAgrupadasPorUnidadNegocio.length === 0"
            indeterminate
            color="primary"></v-progress-circular>

          <div v-else v-for="sedeAgrupada in sedesAgrupadasPorUnidadNegocio" :key="sedeAgrupada.id">
            <h5 class="py-2 mt-4" style="background-color: #ebeff1">
              <v-checkbox
                :input-value="
                  sedeAgrupada.sedes.map((sede) => sede.id).every((sedeId) => sedesSeleccionadas.includes(sedeId))
                "
                value
                :label="sedeAgrupada.nombre"
                dense
                hide-details
                :indeterminate="
                  !sedeAgrupada.sedes.map((sede) => sede.id).every((sedeId) => sedesSeleccionadas.includes(sedeId)) &&
                  sedeAgrupada.sedes.map((sede) => sede.id).some((sedeId) => sedesSeleccionadas.includes(sedeId))
                "
                @change="(valor) => agregarQuitarTodas(valor, sedeAgrupada.sedes)">
              </v-checkbox>
            </h5>

            <v-row>
              <v-col cols="12" md="4" lg="3" xl="2" v-for="sede in sedeAgrupada.sedes" :key="sede.id">
                <v-checkbox
                  v-model="sedesSeleccionadas"
                  :label="sede.nombre"
                  :value="sede.id"
                  dense
                  hide-details></v-checkbox>
              </v-col>
            </v-row>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="blue darken-1" text @click.prevent="aceptar"> Aceptar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <notifications group="notifications" position="top right" />

    <VerPdf ref="verPdf" :fnDescarga="fnDescarga" @cerradoModal="fnDescarga = null" />
  </div>
</template> 

<script>
import ListadoReporteEjecucionPresupuestaria from '../views/ListadoReporteEjecucionPresupuestaria.vue';
import PresupuestosService from '../services';
import VerPdf from '../components/VerPdf.vue';
import SedesUnidadesNegocioMixin from '../mixins/sedes-unidades-negocio-mixin';
import ReportesExcelService from '../services/reportes-excel';
import DescargarExcelMixin from '../mixins/descargar-excel.mixin';
import ListadoReporteDesembolsosPorSedes from '../views/ListadoReporteDesembolsosPorSedes.vue';
import detalleSolicitud from '../services/detalle-solicitud';
import ListadoReporteEjecucionPresupuestariaAgrupado from '../views/ListadoReporteEjecucionPresupuestariaAgrupado.vue';

export default {
  name: 'ReporteEjecucionPresupuestaria',
  mixins: [SedesUnidadesNegocioMixin, DescargarExcelMixin],
  components: {
    ListadoReporteEjecucionPresupuestaria,
    VerPdf,
    ListadoReporteDesembolsosPorSedes,
    ListadoReporteEjecucionPresupuestariaAgrupado,
  },
  data() {
    return {
      getService: PresupuestosService.getEjecucionPresupuestaria,
      mostrarCeros: false,
      fnDescarga: null,
      pdf: null,
      cargandoVerPdf: false,
      tab: JSON.parse(localStorage.getItem('reporteEjecucionPresupuestariaTab')) || 'Por Ítem',
      menuRangoFechas: false,
      rangoFechas: [],
      datosDesembolsosPorSedes: {
        sedes: [],
        clasificadores: [],
        tabla: [],
        totales: {},
      },
      cargandoItemsPorSedes: false,
      itemsAgrupados: [],
      cargandoItemsAgrupados: false,
      expandirTodo: true,
    };
  },
  methods: {
    async listar() {
      const params = {
        sedes: this.sedesSeleccionadas,
        mostrar_ceros: this.mostrarCeros,
        gestion_id: this.gestionId,
      };

      this.listarMixin(params);
    },
    async listarTodo() {
      await this.listar();
      await this.listarItemsPorSedes();
      await this.listarItemsAgrupados();
    },
    async verPdf() {
      const params = {
        sedes: this.sedesSeleccionadas,
        nombres_sedes: this.nombresSedesSeleccionadas,
        mostrar_ceros: this.mostrarCeros,
        gestion_id: this.gestionId,
      };

      this.pdf = null;
      this.cargandoVerPdf = true;

      try {
        const response = await PresupuestosService.getReporteEjecucionPresupuestaria(params);
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const pdf = URL.createObjectURL(blob);

        this.fnDescarga = () => this.descarga(params);

        this.$refs.verPdf.abrir(pdf);
      } catch (err) {
        window.console.log(err);
      } finally {
        this.cargandoVerPdf = false;
      }
    },
    descarga(params) {
      return this.descargarExcel(ReportesExcelService.reporteEjecucionPresupuestaria, null, { params });
    },
    removerSedeSeleccionada(item) {
      const index = this.sedesSeleccionadas.indexOf(item.id);
      if (index >= 0) {
        this.sedesSeleccionadas.splice(index, 1);

        this.listarTodo();
      }
    },
    aceptar() {
      this.listarTodo();
    },
    fechaDeHoy() {
      const hoy = new Date();
      const mes = hoy.getMonth() + 1;
      const dia = hoy.getDate();
      const anio = hoy.getFullYear();

      const mesString = mes < 10 ? `0${mes}` : mes;
      const diaString = dia < 10 ? `0${dia}` : dia;

      return `${anio}-${mesString}-${diaString}`;
    },
    establecerTabSeleccionada() {
      localStorage.setItem('reporteEjecucionPresupuestariaTab', JSON.stringify(this.tab));
    },
    async listarItemsPorSedes() {
      if (this.rangoFechas.length !== 2 || this.sedesSeleccionadas.length === 0) {
        return;
      }

      this.cargandoItemsPorSedes = true;
      this.datosDesembolsosPorSedes = {
        sedes: [],
        clasificadores: [],
        tabla: [],
        totales: {},
      };

      try {
        let fechaInicio = this.rangoFechas[0];
        let fechaFin = this.rangoFechas[1];

        if (this.rangoFechas[0] > this.rangoFechas[1]) {
          fechaInicio = this.rangoFechas[1];
          fechaFin = this.rangoFechas[0];
        }

        const params = {
          sedes_ids: this.sedesSeleccionadas,
          fecha_inicio: fechaInicio,
          fecha_fin: fechaFin,
        };

        const response = await detalleSolicitud.desembolsosPorSedes({ params });
        const data = response.data;
        const datos = data?.datos;

        this.datosDesembolsosPorSedes = datos;
      } catch (err) {
        window.console.log(err);
      } finally {
        this.cargandoItemsPorSedes = false;
      }
    },
    onChangeGestionId() {
      this.setGestionId(this.gestionId);
      this.listar();
      this.listarItemsAgrupados();
    },
    async listarItemsAgrupados() {
      this.cargandoItemsAgrupados = true;
      this.itemsAgrupados = [];

      const params = {
        sedes: this.sedesSeleccionadas,
        mostrar_ceros: this.mostrarCeros,
        gestion_id: this.gestionId,
      };

      try {
        const response = await PresupuestosService.ejecucionPresupuestariaAgrupadaPorCuentas({ params });
        const data = response.data;
        const datos = data?.datos;

        this.itemsAgrupados = datos;
      } catch (err) {
        window.console.log(err);
      } finally {
        this.cargandoItemsAgrupados = false;
      }
    },
  },
};
</script>

<style scoped>
.custom-card {
  border: 1px solid #dfdfdf;
  padding: 8px;
  margin: 0px 8px 0px 8px;
}

::v-deep .custom-pagination .v-pagination__item,
::v-deep .custom-pagination .v-pagination__navigation {
  height: 28px;
  min-width: 28px;
  margin: 0px 4px;
}

::v-deep .v-btn:not(.v-btn--round).v-size--small {
  min-width: 40px;
  padding: 0 6px;
}

::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}
::v-deep .v-text-field .v-input__control .v-input__slot,
::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}
::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}
::v-deep .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer {
  margin-top: 5px;
}

@media (max-width: 1264px) {
  .margen-top {
    margin-top: 6px !important;
  }
}

/* v-date-picker */
::v-deep .accent {
  background-color: #005caf !important;
  border-color: #005caf !important;
}
</style>